import { render, staticRenderFns } from "./provincePlant.vue?vue&type=template&id=6041a49a&scoped=true&"
import script from "./provincePlant.vue?vue&type=script&lang=js&"
export * from "./provincePlant.vue?vue&type=script&lang=js&"
import style0 from "./provincePlant.vue?vue&type=style&index=0&id=6041a49a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6041a49a",
  null
  
)

export default component.exports